interface Params {
  element: HTMLElement;
  offset?: number;
  useBoundingClientRect?: boolean;
}

// scroll to element
const scrollToElement = ({
  element,
  offset = 0,
  useBoundingClientRect
}: Params) => {
  const duration = 300;
  const elOffset = useBoundingClientRect
    ? element.getBoundingClientRect().top + offset
    : element.offsetTop + offset;
  const cosParam = (window.pageYOffset - elOffset) / 2;
  let scrollCount = 0;
  let oldTimestamp = performance.now();

  const step = (newTimestamp) => {
    scrollCount += Math.PI / (duration / (newTimestamp - oldTimestamp));
    if (scrollCount >= Math.PI) window.scrollTo(0, elOffset);

    // check if we have reached the element
    // window.pageYOffset might not be an integer,
    // so we check for a one pixel difference
    if (
      window.pageYOffset >= elOffset - 1 &&
      window.pageYOffset <= elOffset + 1
    )
      return;

    window.scrollTo(
      0,
      Math.round(cosParam + cosParam * Math.cos(scrollCount)) + elOffset
    );
    oldTimestamp = newTimestamp;

    // check if we are at the bottom of the page
    if (
      window.innerHeight + window.pageYOffset + 1 >=
        document.body.scrollHeight &&
      window.pageYOffset < elOffset
    ) {
      return;
    }

    window.requestAnimationFrame(step);
  };

  window.requestAnimationFrame(step);
};
export default scrollToElement;
